export enum tableTypeEnum {
	string = 'string',
	number = 'number',
	date = 'date',
	boolean = 'boolean'
}
